const ID = {
    mainNavToggle: "main-nav",
    userNavToggle: "user-nav",
    mainSiteNav: "main-site-nav",
    userSiteNav: "user-site-nav",
    siteHeaderMenuMobile: "site-header-menu-mobile"
}
const CLASSES = {
    active: "active",
    userNavActive: "user-nav--active",
    siteNavActive: "site-nav--active"
}

const mainNavToggle = document?.getElementById(ID.mainNavToggle);
const userNavToggle = document?.getElementById(ID.userNavToggle);

const mainSiteNav = document?.getElementById(ID.mainSiteNav);
const userSiteNav = document?.getElementById(ID.userSiteNav);

const addHeaderMenuToggleListeners = () => {
    if (mainNavToggle != null) {
        mainNavToggle?.addEventListener('click', () => {
            checkMenuDisplay(userNavToggle);
            updateMenuDisplay('mainSiteNav',mainNavToggle, mainSiteNav);
        });
    }
    if (userNavToggle != null) {
        userNavToggle?.addEventListener('click', () => {
            checkMenuDisplay(mainNavToggle);
            updateMenuDisplay('userSiteNav', userNavToggle, userSiteNav);
        });
    }
}

const checkMenuDisplay = (menuToggle) => {
    if (menuToggle.classList.contains(CLASSES.active)) {
        menuToggle.click();
    }
}

const updateMenuDisplay = (type, menuToggle, nav) => {
    let activeNavClass = type === 'mainSiteNav' ? CLASSES.siteNavActive : CLASSES.userNavActive;

    if (menuToggle.classList.contains(CLASSES.active)) {
        menuToggle.classList.remove(CLASSES.active);
        nav.classList.remove(activeNavClass);
    } else {
        menuToggle.classList.add(CLASSES.active);
        nav.classList.add(activeNavClass);
    }
}

const init = () => {
    addHeaderMenuToggleListeners();
}

export default {
    init
}